// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ValidateAddressRequestModel from '../../model/validate-address-request-model';
import ValidateAddressRequestDTO from '../dto/validate-address-request-dto';
import dtoSchema from '../schemas/validate-address-request-schema';

export default abstract class ValidateAddressRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ValidateAddressRequestDTO>) {
    super();
    if (data) {
      this.countryIso2 = data.countryIso2;
      this.street = data.street;
      this.houseNumber = data.houseNumber;
      this.postalCode = data.postalCode;
      this.postalCodeAddition = data.postalCodeAddition;
      this.city = data.city;
      this.limit = data.limit;
    }
  }
  /**
  */
  countryIso2?: string;
  /**
  */
  street?: string;
  /**
  */
  houseNumber?: string;
  /**
  */
  postalCode?: string;
  /**
  */
  postalCodeAddition?: string;
  /**
  */
  city?: string;
  /**
  * @type {int32}
  */
  limit?: number;

  static toModel(dto: DeepPartial<ValidateAddressRequestDTO>): ValidateAddressRequestModel;
  static toModel(dto: DeepPartial<ValidateAddressRequestDTO> | undefined | null): ValidateAddressRequestModel | undefined;
  static toModel(dto: DeepPartial<ValidateAddressRequestDTO> | undefined | null): ValidateAddressRequestModel | undefined {
    return dto ? new ValidateAddressRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ValidateAddressRequestModel> | ValidateAddressRequestModel): ValidateAddressRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      countryIso2: unwrapped.countryIso2,
      street: unwrapped.street,
      houseNumber: unwrapped.houseNumber,
      postalCode: unwrapped.postalCode,
      postalCodeAddition: unwrapped.postalCodeAddition,
      city: unwrapped.city,
      limit: unwrapped.limit,
    } as ValidateAddressRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ValidateAddressRequestModel, can not map to ValidateAddressRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
